import NotFoundPageView from './NotFoundPage.view';
export * from './NotFoundPage.view';

export const NotFoundPage = (props) => NotFoundPageView(props);

export default NotFoundPage;

